export default __webpack_public_path__ + "static/media/bgVideo.2aaa72c6.png";